import 'global.scss' // app & third-party component styles
import 'antd/dist/antd.css'; 

import React from 'react'
import ReactDOM from 'react-dom'
import { createHashHistory } from 'history'
import firebase from "firebase";
import axios from 'axios'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'connected-react-router'

import reducers from './redux/reducers'
import sagas from './redux/sagas'
import Localization from './localization'
import Router from './router'
import * as serviceWorker from './serviceWorker'

// middlewared
const history = createHashHistory()
const sagaMiddleware = createSagaMiddleware()
const routeMiddleware = routerMiddleware(history)
const middlewares = [sagaMiddleware, routeMiddleware]
const store = createStore(reducers(history), compose(applyMiddleware(...middlewares)))
sagaMiddleware.run(sagas)

//LogRocket.init('flare-partner/partner-app');
// const beamerProductId = 'kBuUPpMz29503'
// beamerInitialize(beamerProductId);


// axios.interceptors.response.use(config =>({ ...config, validateStatus: status => status < 500 }))

axios.interceptors.request.use(async config => {

  config.headers.token = firebase && firebase.auth() && firebase.auth().currentUser && await firebase.auth().currentUser.getIdToken()
  return config
}, (error) => {
  return Promise.reject(error)
})


ReactDOM.render(
  <Provider store={store}>
    <Localization>
      <Router history={history} />
    </Localization>
  </Provider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
export { store, history }
